export default function parseLocaleNumber(value: string) {
  if(!value) return ''
  return value.replace(' ', '').replace(',', '.')
}
